import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./InsuranceDashboard.css";
import { InsuranceReport } from "./InsuraceDashboardComponents/InsuranceReport";
import { InsuranceInfo } from "./InsuraceDashboardComponents/InsuranceInfo";
import { InsuranceTable } from "./InsuraceDashboardComponents/InsuranceTable";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import FETCH from "../../utils/fetch";
import swal from "sweetalert";
import { MODULE_API } from "../../apis";
import ModalVideo from "../ModuleVideos/ModalVideo";
export const InsuranceDashboard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [insuranceData, setInsuranceData] = useState([]);

  const getInsuranceList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products&page=1&limit=50&clientId=${ID}`
            : `?module=Insurance Products&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        setInsuranceData(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deletePost = async (id) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setInsuranceData([]);
          getInsuranceList();
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
  useEffect(() => {
    getInsuranceList();
  }, []);

  return (
    <div className="insuranceMain">
      <ModalVideo module="Insurance" autoOpen={true} />
      <div className="liabilitycreate">
        <button
          className="addbuttonLiablity"
          onClick={() => {
            history.push("/insurance_new");
          }}
        >
          {" "}
          + Add Insurance
        </button>
      </div>
      <div className="insuranceMainReport">
        <InsuranceReport />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insruance-info-main">
        <InsuranceInfo />
        <NewLoader isLoading={loading} />
      </div>
      <div className="insuranceCreditMainTag">
        <InsuranceTable deletePost={deletePost} data={insuranceData && insuranceData} />
        <NewLoader isLoading={loading} />
      </div>
      {/* <div className="liabilityTableCard">
        <LiabilityTable />
        </div>  */}
    </div>
  );
};
